import getFleetNameById from '../../utils/getFleetNameById';
import getNumOfCarsByAreaId from '../../utils/getNumOfCarsByAreaId';
import {
  alphabeticalSorter,
  alphabeticalSorterFor,
  chronologicalSorterFor,
  renderDate,
  getRenderLink,
  getRenderAction,
} from '../shared/TableLayout';
import isDesktop from '../../utils/sizeHelpers';
import { selectAreaAndSwitchToMapView } from '../../redux/store/ui/common';
import { AreaData } from '../../@types';
import fixGeoJSONCoordinates from '../../utils/fixGeoJSONCoordinates';
import getBoundsFromPoints from '../../utils/getBoundsFromPoints';

const getCenterFromGeoJson = (geoJsonData: any) => {
  const geoJson = fixGeoJSONCoordinates(geoJsonData);
  const bounds = getBoundsFromPoints(
    // @ts-ignore
    geoJson.features[0].geometry.coordinates[0]
  );
  const center = {
    lat: (bounds.north + bounds.south) / 2,
    lng: (bounds.east + bounds.west) / 2,
  };

  return `${center.lat?.toString()?.slice(0, 10)},${center.lng
    ?.toString()
    ?.slice(0, 10)}`;
};

const getColumns = ({ cars, fleets, dispatch, intl }: any) => {
  const renderFleet = (fleetId: any) => (
    <span>{getFleetNameById(fleets, fleetId)}</span>
  );

  const renderNumOfCars = (areaId: any) => {
    return <span>{getNumOfCarsByAreaId(cars, areaId)}</span>;
  };

  const renderAction = getRenderAction((area: AreaData) =>
    dispatch(selectAreaAndSwitchToMapView(area))
  );

  const renderFleetStyle = (fleetStyle: any) => (
    <span>{fleetStyle || '-'}</span>
  );

  const renderCenter = (_, record) => (
    <span>{getCenterFromGeoJson(record?.geoJSONData)}</span>
  );

  return [
    {
      title: intl.formatMessage({
        id: 'fleetadmin.area.table.area',
        defaultMessage: 'Area',
      }),
      dataIndex: 'name',
      ellipsis: true,
      width: isDesktop() ? 200 : 150,
      fixed: 'left' as 'left',
      render: getRenderLink(),
      sorter: alphabeticalSorterFor('name'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.area.table.fleet',
        defaultMessage: 'Fleet',
      }),
      dataIndex: 'fleetId',
      render: renderFleet,
      ellipsis: true,
      width: 150,
      sorter: (areaA: { fleetId: any }, areaB: { fleetId: any }) => {
        const fleetNameA = getFleetNameById(fleets, areaA.fleetId);
        const fleetNameB = getFleetNameById(fleets, areaB.fleetId);
        return alphabeticalSorter(fleetNameA, fleetNameB);
      },
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.area.table.fleetstyle',
        defaultMessage: 'Fleet Style',
      }),
      dataIndex: 'fleetStyle',
      render: renderFleetStyle,
      ellipsis: true,
      width: 150,
      sorter: alphabeticalSorterFor('fleetStyle'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.area.table.novehicles',
        defaultMessage: 'No.Vehicles',
      }),
      dataIndex: 'id',
      render: renderNumOfCars,
      width: 150,
      sorter: (areaA: { id: any }, areaB: { id: any }) => {
        const A = getNumOfCarsByAreaId(cars, areaA.id);
        const B = getNumOfCarsByAreaId(cars, areaB.id);
        return B - A;
      },
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.area.table.createdat',
        defaultMessage: 'Created at',
      }),
      dataIndex: 'createdAt',
      width: 150,
      render: renderDate,
      sorter: chronologicalSorterFor('createdAt'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.area.table.lastmodified',
        defaultMessage: 'Last modified',
      }),
      dataIndex: 'lastUpdatedAt',
      width: 150,
      render: renderDate,
      sorter: chronologicalSorterFor('lastUpdatedAt'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.area.table.location',
        defaultMessage: 'Location',
      }),
      dataIndex: 'location',
      width: 220,
      render: renderCenter,
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.area.table.action',
        defaultMessage: 'Action',
      }),
      dataIndex: 'operation',
      width: 170,
      render: renderAction,
    },
  ];
};

export default getColumns;
